import React from 'react';
import { motion } from 'framer-motion';
const steps = [{
  n: '1',
  title: 'Instant download',
  desc: 'Purchase and get immediate access to the complete ebook and all 5 bonuses. Start whenever you want, no waiting.'
}, {
  n: '2',
  title: 'Follow the visual method',
  desc: 'Learn cognitive health, assessment criteria, mobility protocols, nutrition, home safety and caregiver wellness in an order designed so you never get lost. The system is your roadmap.'
}, {
  n: '3',
  title: 'Complete the 6-volume system',
  desc: 'Study step by step, apply what you learned with your parent from day one and consolidate a complete care system so you manage their aging with real confidence by volume 6.'
}];
export function Steps() {
  return <section aria-label="How it works" className="bg-transparent" data-id="element-180" data-mp="2624snitz6t74">
      <div className="mx-auto max-w-4xl px-5 py-12" style={{
      paddingTop: "12px",
      paddingBottom: "17px"
    }} data-id="element-181" data-mp="25zqzxgmrpt2q">
        <h2 className="text-center font-display text-2xl font-black text-plum sm:text-3xl" data-id="element-182" data-mp="2a1ch3e6c4tiq">
          How You'll Progress Starting Today
        </h2>
        <p className="mt-3 text-center text-sm text-plum/60" data-id="element-183" data-mp="1lb7po1o9dsfs">In just 3 simple steps</p>

        <ol className="mt-10 space-y-4" data-id="element-184" data-mp="201osnpgjkqes">
          {steps.map((s, i) => <motion.li key={s.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.4,
          delay: i * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="flex items-start gap-4 rounded-2xl border border-grape/15 bg-white p-5" data-id="element-185" data-mp="202zuhjqffo39" data-mpi={i}>
              <span className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-grape font-display text-base font-black text-white" data-id="element-186" data-mp="1hc8ngotww9s1">
                {s.n}
              </span>
              <div data-id="element-187" data-mp="2so9gifxt6kdl">
                <h3 className="text-base font-bold text-plum" data-id="element-188" data-mp="2srxcdlqq7ivh">{s.title}</h3>
                <p className="mt-1 text-sm leading-relaxed text-plum/65" data-id="element-189" data-mp="2npy9ecywenz2">{s.desc}</p>
              </div>
            </motion.li>)}
        </ol>
      </div>
    </section>;
}